export default "__VITE_ASSET__DzJUC3rR__"